export const PE_ADD_MORE_VALIDATION_MESSAGE = {
  nameRequired: "Name is required",
} as const;
